import { render, staticRenderFns } from "./TheThemePanel.vue?vue&type=template&id=dd5014b6&"
import script from "./TheThemePanel.vue?vue&type=script&lang=js&"
export * from "./TheThemePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports